export enum UserStatus {
  Active = "active",
  Inactive = "inactive",
  Provisioned = "provisioned",
}
